import CustomerDataContainer from 'containers/CustomerData/index'
import React from 'react'

const CustomerDataPage = () => {
  return (
    <div><CustomerDataContainer/></div>
  )
}

export default CustomerDataPage